import actions from "./actions";

const initState = {
  investors: [],
  proposals: [],
  allInvestors: [],
  allProposalNumbers: [],
};

export default function investorsReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_PROPOSALS_SUCCESS:
      return {
        ...state,
        proposals: action.list,
      };

    case actions.RESET:
      return {
        ...state,
        investors: [],
      };

    case actions.FETCH_ALL_INVESTORS_SUCCESS:
      return {
        ...state,
        allInvestors: action.allInvestors,
      };

    case actions.FETCH_ALL_PROPOSAL_NUMBERS_SUCCESS:
      return {
        ...state,
        allProposalNumbers: action.allProposalNumbers,
      };

    default:
      return state;
  }
}
